// Keywords are free text capped at 100 characters, and a badge will not break a
// long unbroken one on its own — it just widens its container, overflowing the
// rule modal and stretching the keywords column in the rules table.
const keywordBadgeStyle = {
    maxWidth: '100%',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    textAlign: 'left',
};

export default keywordBadgeStyle;
